const SHIPPING_COUNTRIES = [
    {
        countryCode: 'US',
        countryLongName: 'United States'
    },
    {
        countryCode: 'CA',
        countryLongName: 'Canada',
        currency: {
            code: 'CAD',
            name: 'Canada',
            symbol: '$'
        }
    }
];

function getShippingCountryList() {
    return Promise.resolve(SHIPPING_COUNTRIES);
}

export default getShippingCountryList;
